import * as React from 'react'

const SvgDashBoardTutoringIcon = (props) => (
  <svg
    width="49"
    height="48"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.333496"
      width="48"
      height="48"
      rx="10"
      fill="url(#paint0_linear_3997_87592)"
    />
    <path
      d="M15.3335 28V19.2C15.3335 18.0799 15.3335 17.5198 15.5515 17.092C15.7432 16.7157 16.0492 16.4097 16.4255 16.218C16.8533 16 17.4134 16 18.5335 16H30.1335C31.2536 16 31.8137 16 32.2415 16.218C32.6178 16.4097 32.9238 16.7157 33.1155 17.092C33.3335 17.5198 33.3335 18.0799 33.3335 19.2V28H27.9962C27.7516 28 27.6294 28 27.5143 28.0276C27.4122 28.0521 27.3147 28.0925 27.2252 28.1474C27.1243 28.2092 27.0378 28.2957 26.8649 28.4686L26.8021 28.5314C26.6292 28.7043 26.5427 28.7908 26.4418 28.8526C26.3523 28.9075 26.2548 28.9479 26.1527 28.9724C26.0376 29 25.9153 29 25.6708 29H22.9962C22.7516 29 22.6294 29 22.5143 28.9724C22.4122 28.9479 22.3147 28.9075 22.2252 28.8526C22.1243 28.7908 22.0378 28.7043 21.8649 28.5314L21.8021 28.4686C21.6292 28.2957 21.5427 28.2092 21.4418 28.1474C21.3523 28.0925 21.2548 28.0521 21.1527 28.0276C21.0376 28 20.9153 28 20.6708 28H15.3335ZM15.3335 28C14.7812 28 14.3335 28.4477 14.3335 29V29.3333C14.3335 29.9533 14.3335 30.2633 14.4016 30.5176C14.5866 31.2078 15.1257 31.7469 15.8159 31.9319C16.0702 32 16.3802 32 17.0002 32H31.6668C32.2868 32 32.5968 32 32.8511 31.9319C33.5413 31.7469 34.0804 31.2078 34.2653 30.5176C34.3335 30.2633 34.3335 29.9533 34.3335 29.3333C34.3335 29.0233 34.3335 28.8683 34.2994 28.7412C34.207 28.3961 33.9374 28.1265 33.5923 28.0341C33.4651 28 33.3102 28 33.0002 28H32.3335"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3997_87592"
        x1="26.3645"
        y1="1.2889e-06"
        x2="36.3341"
        y2="45.8313"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3F76FF" />
        <stop offset="1" stopColor="#444CE7" />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgDashBoardTutoringIcon
